export default {
  SET_D_SUMMARIES: function (state, payloads) {
    state.dSummaries = payloads;
  }
}
